import { Navigate, Outlet } from "react-router";
import { useAuth } from "@/lib/auth-context";
import { Skeleton } from "@/components/ui/skeleton";

export function RedirectIfAuthenticated() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Skeleton className="h-10 w-10 rounded-full" />
      </div>
    );
  }

  if (user) {
    return <Navigate to="/stocks" replace />;
  }

  return <Outlet />;
}
